<template>
  <div></div>
</template>

<script>
import moment from 'moment/moment'

export default {
  beforeDestroy () {
    this.wsClose = true
    this.onClose()
    document.removeEventListener('visibilitychange', this.backgroundBrowser)
  },
  computed: {
    siteinfo () {
      return this.$store.state.authentication
    },
    isTalkOpen () {
      return this.$store.getters['talk']
    },
    hasChannel () {
      return this.$store.getters['talkChannel']
    }
  },
  watch: {
    isTalkOpen (isOpen) {
      if (isOpen) {
        this.setCount(this.cid, 0)
      }
    },
    hasChannel (cid) { // 채널이 생기면 ws 연결
      if (cid) {
        this.cid = cid
        this.wsConnect()
      }
    }
  },
  created () {
    setTimeout(() => {
      const siteinfo = this.siteinfo
      const key = `${siteinfo.site}_stayTalk`
      const cid = (siteinfo.space && siteinfo.k) || localStorage.getItem(key)
      const talkLastKey = localStorage.getItem(`talkLatest_${cid}`)
      const count = localStorage.getItem(`talkReceived_${cid}`)
      if (cid) {
        this.cid = cid
        this.count = count
        this.$store.commit('talk/received', count)
        this.wsConnect()
        this.$store.dispatch('talk/getSetting').then((res) => {
          const setting = res && res.setting
          this.isTranslate = setting && setting.disabledTranslate !== true
        })
        if (talkLastKey) {
          this.getRecivedMessage(cid, talkLastKey)
        }
        document.addEventListener('visibilitychange', this.backgroundBrowser)
      }
    }, 1000)
  },
  data () {
    return {
      cid: '',
      wsStatus: null,
      wsClose: false,
      isBackground: false,
      count: 0,
      isTranslate: true
    }
  },
  methods: {
    // 백그라운드일 때는 읽음표시를 하지 않기 위한 visibilityState 체크
    backgroundBrowser () {
      this.isBackground = document.visibilityState === 'hidden'
    },
    getRecivedMessage (cid, talkLastKey) {
      const data = {
        cid: cid,
        page: 100
      }
      this.$store.dispatch('talk/getMessage', data).then((res) => {
        if (res && res.Items && res.Items.length > 0) {
          const count = res.Items.filter(x => x.from !== 'user' && !x.readByUser).length
          this.setCount(cid, count)
        }
      })
    },
    wsConnect () {
      if (this.socket === undefined || this.socket.readyState === 3) {
        this.socket = new WebSocket(process.env.VUE_APP_WS_TALK)
        this.socket.onopen = (e) => {
          this.onOpen(e)
        }
        this.socket.onclose = (e) => {
          this.onClose(e)
        }
        this.socket.onmessage = (e) => {
          this.onMessage(e)
        }
        this.socket.onerror = (e) => {
          this.onError(e)
        }
      }
    },
    readByUser (cid, id) {
      const data = {
        cid: cid,
        msgIds: [id]
      }
      if (id) {
        this.$store.dispatch('talk/readByUser', data)
      }
    },
    onOpen (e) {
      const data = {
        action: 'login',
        siteid: this.$store.getters['authentication/getAuthInfo'].site,
        cid: this.cid
      }
      this.wsStatus = 'start'
      this.sendData(JSON.stringify(data))
    },
    sendData (data) {
      this.wsStatus = 'send'
      this.socket.send(data)
    },
    async onMessage (e) {
      const res = JSON.parse(e.data)
      this.wsStatus = 'message'
      /**
       * ws message는 센터에서 온 정보만 다룬다
       * sc-post-message
       * from !== user
       */
      if (res && res.cid && res.cmd && res.cmd.includes('post-message')) {
        /**
         * res.cmd
         * sc-post-message: 센터에서 메시지 도착
         * sc-read-by-user: 센터에서 읽음
         * ws로 오는 데이터에 createat이 없으므로 현재 시각 추가
         * 도착한 메시지에 번역데이터 추가
         */
        const lang = this.$route.params.ln
        const translateData = {
          msgId: res.msgId,
          text: res.text,
          to: lang
        }
        res.createat = moment().toISOString()
        this.setCount(res.cid, this.isTalkOpen ? 0 : this.count + 1)
        if (this.isTalkOpen && !this.isBackground) {
          // 읽음 표시는 ws 받는 즉시 한다
          this.readByUser(res.cid, res.msgId)
        }
        if (res.from !== 'user' && this.isTranslate) {
          /**
           * 센터에서 온 메시지는 번역을 한번 한 뒤에 추가
           * 번역된 데이터는 db에 저장되어
           * 이후 함께 호출됨
           */
          await this.$store.dispatch('talk/getTranslate', translateData).then((result) => {
            const translateData = result && result.status === 200 && result.message
            if (translateData) {
              res.translatedText = translateData.text
            }
          })
        }
        this.$store.commit('talk/gotMessage', res)
      } else if (res && res.cmd && res.cmd.includes('sc-update') && res.func && res.func.includes('update-setting')) {
        this.$store.commit('talk/updateSetting', true)
      } else if (res && res.reason && res.reason.includes('channel not found')) {
        this.socket.close()
      }
    },
    async onClose () {
      const cid = this.cid
      if (this.socket) {
        this.socket.close()
      }
      if (cid && !this.wsClose) {
        this.$store.dispatch('talk/getChannel', { cid: cid }).then((res) => {
          if (res) {
            setTimeout(() => {
              this.wsConnect()
            }, 3000)
          }
        })
      }
    },
    onError (e) {
      const cid = this.cid
      this.wsStatus = 'error'
      if (cid && !this.wsClose) {
        this.$store.dispatch('talk/getChannel', { cid: cid }).then((res) => {
          if (res) {
            setTimeout(() => {
              this.wsConnect()
            }, 3000)
          }
        })
      }
    },
    setCount (cid, count) {
      const key = `talkReceived_${cid}`
      this.count = Number(count)
      localStorage.setItem(key, count)
      this.$store.commit('talk/received', count)
    }
  }
}
</script>
